<template>
  <div class="switch-buttons">
    <div
      class="field checkbox-group"
      :style="{
        display: 'flex',
        flexDirection: configs.parameters['Orientation'] === 'v' ? 'column' : 'row'
      }"
    >
      <label
        v-for="(item, index) in configs.buttons"
        :key="index"
        class="button"
        :style="
          buttons[index]
            ? {
                color: '#fff',
                borderColor: item.parameters['Button color'],
                backgroundColor: item.parameters['Button color'],
                marginBottom:
                  configs.parameters['Orientation'] === 'v' && index !== configs.buttons.length - 1 ? '0.75rem' : '0',
                marginRight:
                  configs.parameters['Orientation'] === 'h' && index !== configs.buttons.length - 1 ? '0.75rem' : '0',
                fontSize: configs.parameters['Button size'] === 'default' ? 'unset' : configs.parameters['Button size']
              }
            : {
                color: item.parameters['Button color'],
                borderColor: item.parameters['Button color'],
                backgroundColor: '#fff',
                marginBottom:
                  configs.parameters['Orientation'] === 'v' && index !== configs.buttons.length - 1 ? '0.75rem' : '0',
                marginRight:
                  configs.parameters['Orientation'] === 'h' && index !== configs.buttons.length - 1 ? '0.75rem' : '0',
                fontSize: configs.parameters['Button size'] === 'default' ? 'unset' : configs.parameters['Button size']
              }
        "
      >
        <input type="checkbox" v-model="buttons[index]" :hidden="true" @change="checked(index)" />
        {{ item.displayed_name }}
      </label>
    </div>
    <b-field class="apply">
      <edit-button :editOptions="['Apply']" @click="apply()">
        <template>
          <span class="text">{{ $t('button.apply') }}</span>
        </template>
      </edit-button>
    </b-field>
  </div>
</template>
<script>
import EditButton from '@/components/EditButton'

export default {
  name: 'DashboardSwitchButtons',
  components: {
    EditButton
  },
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      buttons: []
    }
  },
  mounted() {
    this.rerender()
  },
  watch: {
    configs: {
      deep: true,
      immediate: true,
      handler: 'rerender'
    }
  },
  methods: {
    rerender() {
      this.buttons = [...this.items]
      this.$forceUpdate()
    },
    checked(index) {
      if (this.configs.parameters['Logic'] == 'or') {
        this.buttons = this.buttons.map((item, i) => {
          if (i != index) {
            return false
          }
          return true
        })
      }
    },
    apply() {
      this.$emit('apply', { buttons: this.buttons })
    }
  }
}
</script>

<style lang="scss">
.switch-buttons {
  display: contents;
  flex-direction: column;
  width: 100%;
  height: 100%;
  //padding-top: 1.75rem;
  //padding-bottom: 1.75rem;
  .apply {
    justify-content: right;
    display: flex;
  }
}
</style>
